/// <reference types="./disclosure.d.mts" />
import * as $unsafe from "../../../common_common/gleam/unsafe.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $a from "../../../lustre/lustre/attribute.mjs";
import * as $el from "../../../lustre/lustre/element.mjs";
import * as $e from "../../../lustre/lustre/event.mjs";
import * as $sketch from "../../../sketch/sketch.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import { percent, px } from "../../../sketch/sketch/css/length.mjs";
import * as $html from "../../../sketch_lustre/sketch/lustre/element/html.mjs";
import * as $colors from "../../ds/colors.mjs";
import * as $icons from "../../ds/icons.mjs";
import * as $disclosure from "../../ds/internals/components/disclosure/disclosure.mjs";
import * as $events from "../../ds/internals/components/events.mjs";
import * as $shadows from "../../ds/shadows.mjs";
import * as $text from "../../ds/typography/text.mjs";
import { Ok, toList, prepend as listPrepend } from "../../gleam.mjs";

function separator() {
  let _pipe = $css.class$(
    toList([
      $css.margin_("0px 12px"),
      $css.width_("calc(100% - 24px)"),
      $css.height(px(1)),
      $css.background($colors.light.grey_400),
    ]),
  );
  return $html.hr(_pipe, toList([]));
}

export function group(style, attributes, children) {
  let children$1 = $list.intersperse(children, separator());
  let _pipe = $css.class$(
    toList([
      $css.width(percent(100)),
      $css.background($colors.light.grey_50),
      $css.border_radius(px(8)),
      $css.box_shadow($shadows.s()),
      $css.overflow("auto"),
      $css.scrollbar_gutter("stable"),
      $css.selector("::-webkit-scrollbar", toList([$css.width(px(13))])),
      $css.selector(
        "::-webkit-scrollbar:horizontal",
        toList([$css.height(px(13))]),
      ),
      $css.selector(
        "::-webkit-scrollbar-thumb",
        toList([
          $css.box_shadow("inset 0 0 8px 8px " + $colors.light.grey_400),
          $css.border("solid 2px transparent"),
          $css.border_radius(px(14)),
          $css.transition("box-shadow .3s"),
        ]),
      ),
      $css.selector(
        "::-webkit-scrollbar-thumb:vertical",
        toList([$css.border_left_width(px(3))]),
      ),
      $css.selector(
        "::-webkit-scrollbar-thumb:horizontal",
        toList([$css.border_top_width(px(3))]),
      ),
      $css.selector(
        "::-webkit-scrollbar-track:vertical",
        toList([$css.border_left("solid 1px " + $colors.light.grey_200)]),
      ),
      $css.selector(
        "::-webkit-scrollbar-track:horizontal",
        toList([$css.border_top("solid 1px " + $colors.light.grey_200)]),
      ),
      $css.compose(style),
    ]),
  );
  return $html.div(_pipe, attributes, children$1);
}

export function group_(attributes, children) {
  let _pipe = $css.class$(
    toList([
      $css.width(percent(100)),
      $css.background($colors.light.grey_50),
      $css.border_radius(px(8)),
      $css.box_shadow($shadows.s()),
    ]),
  );
  return $html.div(_pipe, attributes, children);
}

export function disclosure(attributes, children) {
  let children$1 = $a.property("children-nodes", $unsafe.coerce(children));
  let passthrough = $events.passthrough();
  let attributes$1 = listPrepend(
    children$1,
    listPrepend(passthrough, attributes),
  );
  return $el.element($disclosure.tag, attributes$1, toList([]));
}

export function disabled(value) {
  return $a.attribute(
    "disabled",
    (() => {
      if (value) {
        return "true";
      } else {
        return "false";
      }
    })(),
  );
}

export function expanded(value) {
  return $a.attribute(
    "expanded",
    (() => {
      if (value) {
        return "true";
      } else {
        return "false";
      }
    })(),
  );
}

export function name(value) {
  return $a.name(value);
}

export function on_expanded(msg) {
  return $e.on(
    "expanded",
    $decode.subfield(
      toList(["detail", "expanded"]),
      $decode.bool,
      (expanded) => { return $decode.success(msg(expanded)); },
    ),
  );
}

export function heading(attributes, children) {
  return $disclosure.heading(attributes, children);
}

export function marker() {
  let _pipe = $css.class$(
    toList([
      $css.flex_shrink(0.0),
      $css.width(px(20)),
      $css.height(px(20)),
      $css.border("1px solid " + $colors.light.grey_400),
      $css.border_radius(px(10)),
      $css.transition("transform .3s"),
    ]),
  );
  return $html.div(
    _pipe,
    toList([$a.class$("marker")]),
    toList([$icons.arrow_dropdown()]),
  );
}

export function summary(attributes, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.medium)),
      $css.color($colors.light.grey_800),
      $css.display("flex"),
      $css.align_items("center"),
      $css.gap(px(8)),
    ]),
  );
  return $html.div(
    _pipe,
    listPrepend($a.class$("summary"), attributes),
    children,
  );
}

export function panel(attributes, children) {
  return $disclosure.panel(attributes, children);
}

export function register(stylesheet) {
  return $result.try$(
    $disclosure.register(stylesheet),
    (_) => { return new Ok(undefined); },
  );
}
